"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = $axios;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _axios = _interopRequireDefault(require("axios"));
var _store = _interopRequireDefault(require("@/store"));
var _elementUi = require("element-ui");
var _index = _interopRequireDefault(require("@/lang/index"));
var _auth = require("@/utils/auth");
// import router from '@/router'

// import { Message } from 'element-ui'

// Token expired num
var tokenExpiredNum = 0;

// language map
var languageMap = {
  'cn': 'zh',
  'en': 'en'
};
function $axios(options) {
  return new Promise(function (resolve, reject) {
    var instance = _axios.default.create({
      baseURL: options.module ? process.env["VUE_APP_BASE_API_".concat(options.module)] : process.env.VUE_APP_BASE_API,
      timeout: options.timeout || 120000,
      headers: {
        'x-api-key': process.env.VUE_APP_APIM_KEY,
        'Ocp-Apim-Trace': 'true',
        'X-Language': languageMap[_store.default.getters.language],
        'X-Country': _store.default.getters.language && _store.default.getters.language.toUpperCase(),
        'Accept-Locale': languageMap[_store.default.getters.language]
      }
    });

    // request 拦截器
    instance.interceptors.request.use(/*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(config) {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // console.log('----config---', config)
              // if (config.url.indexOf('get_dealer_qrcode_v2') > -1) {
              //   config.headers['token'] = process.env.VUE_APP_QR_TOKEN
              // } else {
              if (options.headers && options.headers.token) {
                // let each request carry token
                // ['X-Token'] is a custom headers key
                // please modify it according to the actual situation
                config.headers['token'] = options.headers.token;
              } else if ((0, _auth.getToken)()) {
                config.headers['token'] = (0, _auth.getToken)();
              } else {
                config.headers['token'] = process.env.VUE_APP_PUBLIC_TOKEN;
              }
              // 检查sasToken
              _context.n = 1;
              return (0, _auth.checkSasToken)(config);
            case 1:
              return _context.a(2, config);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), function (error) {
      // do something with request error
      console.log('request error----', error); // for debug

      return Promise.reject(error);
    });

    // response interceptor
    instance.interceptors.response.use(function (response) {
      // console.log('response---', response)
      var res = response.data;
      // const url = response.config.url
      // console.log('/////-response-----res----------', res)

      // 下载excel文件时进行特殊处理，头部status返回200时直接返回数据
      if (response.headers['content-type'] && (response.headers['content-type'].includes('excel') || response.headers['content-type'].includes('zip')) && response.status === 200) {
        return response;
      }
      if (!res.success) {
        // 50008: Illegal token; -201: Token expired;
        if (res.code === '-201' || res.code === '-301') {
          if (tokenExpiredNum) {
            return Promise.reject(res);
          }
          tokenExpiredNum++;
          // to re-login
          // if (url.indexOf('login-out') === -1) {
          _elementUi.MessageBox.confirm(_index.default.t('MessageBox.logOut.content'), _index.default.t('MessageBox.logOut.title'), {
            confirmButtonText: _index.default.t('MessageBox.logOut.confirm'),
            cancelButtonText: _index.default.t('common.cancel'),
            type: 'warning'
          }).then(function () {
            _store.default.dispatch('user/resetToken').then(function () {
              location.reload();
            });
          }).catch(function () {
            tokenExpiredNum = 0;
            console.log('cancel');
          });
          // } else {
          //   // 退出接口，直接清除token，不询问
          //   store.dispatch('user/resetToken').then(() => {
          //     location.reload()
          //   })
          // }
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
          return Promise.reject(res);
        }
        if (!options.hideError && res.errorInfos && res.errorInfos.length > 0) {
          res.errorInfos.forEach(function (item) {
            setTimeout(function () {
              (0, _elementUi.Message)({
                message: item.errMsg || 'Error',
                type: 'error',
                duration: 1.5 * 1000
              });
            });
          });
        }
        // return Promise.reject(new Error(res.message || 'Error'))
        return Promise.reject(res);
      } else {
        return res;
      }
    }, function (err) {
      console.log('response err---------' + err); // for debug

      if (_axios.default.isCancel(err)) {
        return Promise.reject(err);
      }
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = _index.default.t('errorMsg.400');
            break;
          case 401:
            err.message = _index.default.t('errorMsg.401');
            break;
          case 403:
            err.message = _index.default.t('errorMsg.403');
            break;
          case 404:
            // err.message = `请求地址出错: ${err.response.config.url}`
            err.message = _index.default.t('errorMsg.404');
            break;
          case 408:
            err.message = _index.default.t('errorMsg.408');
            break;
          case 500:
            err.message = _index.default.t('errorMsg.500');
            break;
          case 501:
            err.message = _index.default.t('errorMsg.501');
            break;
          case 502:
            err.message = _index.default.t('errorMsg.502');
            break;
          case 503:
            err.message = _index.default.t('errorMsg.503');
            break;
          case 504:
            err.message = _index.default.t('errorMsg.504');
            break;
          case 505:
            err.message = _index.default.t('errorMsg.505');
            break;
          default:
        }
      }

      // 超时
      if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
        err.message = _index.default.t('errorMsg.timeout');
      }
      (0, _elementUi.Message)({
        message: err.message,
        type: 'error',
        duration: 1.5 * 1000
      });
      return Promise.reject(err);
    });

    // 请求处理
    instance(options).then(function (res) {
      resolve(res);
      return false;
    }).catch(function (error) {
      console.log('instance error-----', error);
      reject(error);
    });
  });
}